import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const ProfilePage = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    // This page handles the auth redirect and then redirects to appropriate dashboard
    if (user && !loading) {
      // Redirect to appropriate dashboard based on user role
      if (user.role === 'admin') {
        window.location.href = '/admin-dashboard';
      } else if (user.role === 'practitioner') {
        window.location.href = '/practitioner-dashboard';
      } else {
        window.location.href = '/member-dashboard';
      }
    }
  }, [user, loading]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white pt-20 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-xl text-purple-700 font-body">Authenticating...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-20 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-purple-800 mb-4 font-title">Welcome to The Wisdom Network</h1>
        <p className="text-lg text-purple-700 font-body">Setting up your account...</p>
      </div>
    </div>
  );
};

export default ProfilePage;